<template>
	<v-container>
		<v-row v-if="error">
			<v-col xs="12" sm="6" offset-sm="3">
				<app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
			</v-col>
		</v-row>
		<v-row>
			<v-col xs="12">
				<v-card>
					<v-card-text>
						<v-container>
							<v-form @submit.prevent="onSave">
								
								<v-row>
									<v-col >
										<img :src="imageUrl" class="image" >
										<div v-if="imageUrl == null" class="image text-center"><p class="d-inline-block mt-9 display-1 grey--text ">Your Logo Here</p></div>
										<img class="invoiceNames" src="../assets/namesInvoice.png" alt="">
									</v-col>
								</v-row>

								<v-row>
									<v-col xs="12" sm="6" >
										<v-btn raised class="primary" @click="onPickFile">Upload Logo</v-btn>
										<input
										type="file"
										style="display: none"
										ref="fileInput"
										accept="image/*"
										@change="onFilePicked">
									</v-col>
								</v-row>

								<v-row>
									<v-col xs="12" sm="6">
										<v-text-field
										name="CompanyName"
										label="Company Name"
										id="CompanyName"
										v-model="companyName"
										autocomplete="off"
										type="text"
										></v-text-field>
									</v-col>

									<v-col xs="12" sm="6">
										<v-text-field
										name="companyPhone"
										label="Company Phone #"
										id="companyPhone"
										v-model="companyPhone"
										placeholder="555-456-7890"
										type="tel" 
										autocomplete="off"
										></v-text-field>
									</v-col>
								</v-row>

								<v-row>
									<v-col xs="12">
										<v-text-field
										name="CompanyWebsite"
										label="Company Website"
										id="CompanyWebsite"
										v-model="companyWebsite"
										type=""
										autocomplete="off"
										></v-text-field>
									</v-col>
								</v-row>

								<!-- <v-row>
									<v-col xs="12">
										<v-text-field
										name="CompanyFooter"
										label="Company Footer"
										id="CompanyFooter"
										v-model="footer"
										type="text"
										autocomplete="off"
										></v-text-field>
									</v-col>
								</v-row> -->

								<v-row>
									<v-col xs="12">
										<v-btn left class="primary mr-3" type="submit" :disabled="loading" :loading="loading">
											Save Changes
										</v-btn>
										<!-- <v-btn left class="primary" type="submit" :disabled="loading">
											Finish Later
										</v-btn> -->
									</v-col>
								</v-row>
							</v-form>
						</v-container>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	data () {
		return {
			imageUrl: null,
			image: '',
			companyName: '',
			companyPhone: '',
			companyWebsite: '',
			footer: 'Thank You Very Much For Your Business!'
		}
	},
	computed: {
		User () {
			return this.$store.getters.user
		},
		company () {
			return this.$store.getters.company
		},
		error () {
			return this.$store.getters.error
		},
		loading () {
			return this.$store.getters.loading
		}
	},
	watch: {
		User (value) {
			if (value !== null && value !== undefined) {
				// this.$router.push('/options')
			}
		}
	},
	methods: {
		onSave () {
			let companyInfo = {
				imageUrl: this.imageUrl,
				companyName: this.companyName,
				companyPhone: this.companyPhone,
				companyWebsite: this.companyWebsite,
				footer: this.footer,
				priceDisclosure: "*** Prices Include Tax, Labor, Parts & One Year Warranty",
				emailMessage: 'Recommended Options To Help Improve The Comfort In Your Home',
				dateCreated: new Date().toDateString(),
				subscribed: false,
				active: false
			}
			// this.$store.dispatch('createCompanyInfo', companyInfo)
			this.$store.dispatch('updateCompanyInfo', companyInfo)
			this.$store.commit('drawerMenu', false)
		},
		onPickFile (event) {
			this.$refs.fileInput.click()
		},
		onFilePicked (event) {
			const files = event.target.files
			let filename = files[0].name
			if (filename.lastIndexOf('.') <= 0) {
				return alert('Please add a valid file!')
			}
			const fileReader = new FileReader()
			fileReader.addEventListener('load', () => {
				this.imageUrl = fileReader.result
				this.$store.commit('imageUrl', this.imageUrl)
			})
			fileReader.readAsDataURL(files[0])
			this.$store.commit('image', files[0])
		},
		onDismissed () {
			this.$store.dispatch('clearError')
		}

	}
}
</script>
<style type="text/css">
.invoiceNames {
	height: 150px;
	width: 100%;
}
.image{
	position: absolute !important;
	height: 150px !important;
	width: 35% !important;
	max-width: 100%;
}
.redLine {
	border: 1px solid red;
}

</style>